import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  children?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  scrollRef?: React.RefObject<HTMLDivElement | null>;
}

const ProductFilterList = ({ classNames = [], children, header, footer, scrollRef }: Props) => (
  <div className={cn("ProductFilterList", [], classNames)}>
    {header && <div className="ProductFilterList__header">{header}</div>}
    {children && (
      <div className="ProductFilterList__children" ref={scrollRef}>
        {children}
      </div>
    )}
    {footer && <div className="ProductFilterList__footer">{footer}</div>}
  </div>
);

export default ProductFilterList;
